import React, {memo, useContext} from 'react';
import {RightSightPopup} from "../../../../layouts/rightSightPopup";
import {UserManagementContext} from "../../provider/_context";
import {Grid} from "@mui/material";
import {Checkbox} from "../../../../common/form/checkbox";
import {Tooltip} from "../../../../common/tooltip";
import {USER_ICON} from "../../icon/icon";
import {ConfirmModal} from "../../../../layouts/rightSightPopup/confirm";
import {useModal} from "../../hooks/useModal";
import './~style.scss'
import {THEME_SEMANTICS} from "../../../../common/theme/_semantics";
import {Text} from "../../../../common/text";
import {useTranslation} from "react-i18next";
import {DISPLAY_NAME_MENU} from "../../../../const/display_name_menu";

export const ModalUserManagement = memo(() => {
  const {t} = useTranslation()
  const { pageState } = useContext(UserManagementContext)
  const {groupEmployee, functions, valueForm, validate} = useModal()

  return (
    <>
     <RightSightPopup
       openModal={pageState.modalUserInfo}
       confirmBeforeClose={true}
       disableSubmit={validate?.canSubmitRule}
       clickClose={() => functions.onCloseModalUserRole()}
       animationClose={functions.closeModalRole}
       header={
         {
           title: t(DISPLAY_NAME_MENU.USER_PAGE.AUTHOR),
           subTitle: t(DISPLAY_NAME_MENU.USER_PAGE.SUBTITLE),
         }
       }
       body={[
         {
           item: (<>
             <div className={"right-sight-popup__group-role--header"}>
               {validate?.errorCheckRules?.status && <span className={"right-sight-popup__group-role--error"}>{validate?.errorCheckRules?.message}</span>}
               <p className={"right-sight-popup__group-role--title"}>{t(DISPLAY_NAME_MENU.USER_PAGE.SELECT_ONE)} <Text color={THEME_SEMANTICS.failed}>*</Text></p>
             </div>
             <Grid container className={"right-sight-popup__group-role"}>
               {groupEmployee?.list?.map(item => (
                 <Grid xs={6} sm={6} md={6} lg={6} item
                       key={item.id}>
                   <div
                     className={"right-sight-popup__group-role--list"}
                     onClick={() => functions.onChangeRule(item.id)}
                     style={{display: 'flex', marginTop: '24px'}}
                   >
                     <Checkbox
                       checked={valueForm?.rules.includes(item.id)}
                     />
                     <span className={'right-sight-popup__group-role--text'}>{item.group_name}</span>
                     <Tooltip placement="bottom" title={item.group_comment || t(DISPLAY_NAME_MENU.USER_PAGE.NOTE_EMPTY)}>
              <span
                style={{
                  marginLeft: 6,
                  display: 'inline-block',
                  transform: 'translateY(2px)',
                }}
              >
                {USER_ICON.question}
              </span>
                     </Tooltip>
                   </div>
                 </Grid>
               ))}
             </Grid>
           </>)
         }
       ]}
       footer={
         {
           cancel: {
             width: 74,
             title: t(DISPLAY_NAME_MENU.GENERAL.CANCEL)
           },
           save: {
             width: 110,
             title: t(DISPLAY_NAME_MENU.GENERAL.SAVE)
           },
         }
       }
       acceptance={() => functions.onSubmitRule()}
     />
     <ConfirmModal
       openModal={pageState.modalConfirmUserRole}
       stylePopup={{height: '148px', width: '400px'}}
       styleFooter={{marginTop: '1rem'}}
       body={<p>{t(DISPLAY_NAME_MENU.GENERAL.CONFIRM_LEAVING_CONTENT)}</p>}
       footer={
         {
           cancel: {
             width: 74,
             title: t(DISPLAY_NAME_MENU.GENERAL.CANCEL)
           },
           acceptance: {
             width: 110,
             title: t(DISPLAY_NAME_MENU.GENERAL.CONFIRM)
           },
         }
       }
       closeModal={() => functions.closeModalRoleConfirm()}
       acceptance={() => functions.acceptanceModalRoleConfirm()}
     />
    </>
  );
})